export default function AdBanners() {
    return (
        <>
            <div className="eo-adBanner m-left"></div>
            <div className="eo-adBanner m-right"></div>
        </>
    )
}